import { Button } from "@somethings-ui/web";
import { Dialog, DialogContent } from "@/components/ui/dialog.tsx";

interface TrainingLevelContextModalProps {
  open: boolean;
  contextCopy: string | null;
  onAcknowledge: () => void;
}

export function TrainingLevelContextModal({
  open,
  contextCopy,
  onAcknowledge,
}: TrainingLevelContextModalProps) {
  return (
    <Dialog open={open}>
      <DialogContent
        className="gap-5 rounded-md bg-surfaces-z3 p-6 sm:max-w-2xl"
        hideCloseButton
        onOpenAutoFocus={(event) => event.preventDefault()}
      >
        <div className="flex flex-col gap-3">
          <h2 className="text-header-2 text-text-primary">
            What&apos;s happening in this level
          </h2>
          {contextCopy && (
            <p className="whitespace-pre-line text-body-1 text-text-secondary">
              {contextCopy}
            </p>
          )}
        </div>

        <div className="flex">
          <Button variant="primary" fullWidth={false} onClick={onAcknowledge}>
            Got it, let&apos;s start
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
